import { CommonModule } from '@angular/common';
import { Component, Input, EventEmitter, Output, OnInit, AfterViewInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { FormBuilder } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { EditorComponent, EditorModule } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { SharedModule } from '../../../shared/shared.module';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { version } from 'js-base64';
import { environment } from '../../../../environments/environment';
import { ZipDownloadService } from '../../../services/zip-download.service';
@Component({
  selector: 'app-step-details',
  standalone: true,
  imports: [CommonModule],
  template: `
     <div class="p-fluid">
      <div class="p-2 bg-white">
        <table class="w-full text-sm border-collapse border-2 border-gray-600">
          <tbody>
            <!-- Row 1 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Name
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.name || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Proposal Name
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.proposal_name || '-' }}
                </span>
              </td>
            </tr>
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Category
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.category || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              Challenge Status
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span 
                  *ngIf="['Reject','Duplicate','Accept'].includes(applicantData?.challenge_status)" 
                  [ngClass]="{
                    'inline-flex items-center px-3 py-1 rounded-full text-xs font-bold border': true,
                    'border-green-200 bg-green-100 text-green-700': applicantData?.challenge_status === 'Accept',
                    'border-yellow-300 bg-yellow-100 text-yellow-700': applicantData?.challenge_status === 'Duplicate',
                    'border-red-200 bg-red-100 text-red-700': applicantData?.challenge_status === 'Reject'
                  }"
                >
                  {{ applicantData?.challenge_status | uppercase}}
                </span>
                <span *ngIf="!['Reject','Duplicate','Accept'].includes(applicantData?.challenge_status)" class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.challenge_status || '-' }}
                </span>
              </td>
            </tr>

           

            <!-- Row 3 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Status
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span
                  class="inline-flex items-center px-3 py-1 rounded-full text-xs border border-green-200 font-bold bg-green-100 text-green-700"
                >
                  {{ applicantData?.status | uppercase }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Challenge No
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.challenge_number || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 4 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Applying As
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span
                  class="inline-flex px-2 py-1 bg-blue-100 text-blue-700 rounded border border-blue-200 mr-2 text-xs font-medium"
                >
                  {{ applicantData?.applying_as || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Technology
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.technology || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 5 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Thematic OC
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.themenetic || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Gender
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.gender || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 6 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Phone Number
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.phone_number || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Email
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.email || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 7 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                State(s)
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <ng-container *ngIf="applicantData?.states?.length; else statesNone">
                  <span
                    *ngFor="let st of applicantData?.states"
                    class="inline-block px-2 py-1 bg-blue-100 text-blue-700 rounded border border-blue-200 mr-2 mb-1 text-xs font-medium"
                  >
                    {{ st?.name || st }}
                  </span>
                </ng-container>
                <ng-template #statesNone>
                  <span class="text-gray-400">-</span>
                </ng-template>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Address
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.address || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 8 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Company Name
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.company_name || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                What You Are
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.what_you || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 9 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Registration No
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.registration_no || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Registration Year
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.registration_year || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 10 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Registered Address
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.registered_address || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Innovation Title
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.innovation_title || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 11 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Title of Innovative Technology
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.title_innovative || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                Terms & Conditions
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.term_condition || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 12 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                {{applicantData?.agencie_1}} Recommendations
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.recommendations_1 || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                {{applicantData?.agencie_1}} Comments
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.comments_1 || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 13 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
              {{applicantData?.agencie_2}} Recommendations
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.recommendations_2 || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                {{applicantData?.agencie_2}} Comments
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.comments_2 || '-' }}
                </span>
              </td>
            </tr>

            <!-- Row 14 -->
            <tr class="border-b">
              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                {{applicantData?.agencie_3}} Recommendations
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.recommendations_3 || '-' }}
                </span>
              </td>

              <td class="px-4 py-2 font-semibold w-1/4 border-2 border-gray-600 bg-gray-100">
                {{applicantData?.agencie_3}} Comments
              </td>
              <td class="px-4 py-2 border-2 border-gray-600">
                <span class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.comments_3 || '-' }}
                </span>
              </td>
            </tr>
             <!-- Row 2 -->
             <tr class="border-b">
               <td class="px-4 py-2 font-semibold  border-2 border-gray-600 ">
                <h4> Recommendation (PI)</h4>

              </td>
              <td colspan="3" class="px-4 py-2 font-semibold  border-2 border-gray-600 ">
                <div class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.recommendation_pi || '-' }}
                </div>
              </td>             
            </tr>
            <tr class="border-b">
             <td class="px-4 py-2 font-semibold  border-2 border-gray-600 ">
                <h4>Description</h4>

              </td>
             <td colspan="3" class="px-4 py-2 font-semibold   border-2 border-gray-600 ">
                <div class="whitespace-pre-wrap min-w-[100px]">
                  {{ applicantData?.description || '-' }}
                  </div>
              </td>
            
                        
            </tr>
            <tr class="border-b">
            <td class="px-4 py-2 font-semibold  border-2 border-gray-600 ">
                <h4>Brief of the proposal & Likely/intended use case</h4>

              </td>
             <td colspan="3" class="px-4 py-2    border-2 border-gray-600 ">
                <div class="whitespace-pre-wrap min-w-[100px]">
                  <span [innerHTML]="applicantData?.brief"></span>
                  </div>
              </td>
            
                        
            </tr>
            
          </tbody>
        </table>
      </div>
      <ng-container *ngIf="!!briefcaseData?.documents?.length; else noDocuments">
        <div class="flex justify-end items-center mt-3">
          <button
            class="px-3 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 transition mb-3"
            type="button"
            (click)="downloadAllDocumentsAsZip()"
            *ngIf="briefcaseData?.documents?.length"
          >
            <i class="pi pi-download mr-1"></i>
            Download All as Zip
          </button>
        </div>
        <div class="flex flex-wrap gap-3 my-2">
          <ng-container *ngFor="let doc of briefcaseData.documents">
            <div 
              class="flex items-center gap-2 p-2 bg-blue-50 rounded-lg shadow-sm border border-blue-100 hover:shadow-md cursor-pointer min-w-[200px] transition-all"
              (mouseenter)="doc._hover = true" (mouseleave)="doc._hover = false"
            >
              <!-- Compact File Icon -->
              <span>
                <ng-container [ngSwitch]="true">
                  <i *ngSwitchCase="doc.type_document?.toLowerCase()?.includes('pdf')" 
                     class="pi pi-file-pdf text-xl text-red-500"></i>
                  <i *ngSwitchCase="doc.type_document?.toLowerCase()?.includes('doc')" 
                     class="pi pi-file-word text-xl text-blue-600"></i>
                  <i *ngSwitchDefault class="pi pi-paperclip text-xl text-gray-400"></i>
                </ng-container>
              </span>
              <div class="flex-1 min-w-0">
                <div class="truncate font-semibold text-xs text-gray-800 flex items-center">
                  {{ doc.name || 'Document' }}
                  <span *ngIf="doc.type_document" class="ml-1 bg-gray-100 text-blue-400 px-1 py-0.5 rounded-full text-2xs uppercase tracking-wide">
                    {{ doc.type_document.replace('.', '') }}
                  </span>
                </div>
                <div *ngIf="doc.size" class="text-2xs text-gray-400 truncate mt-0.5">
                  {{ doc.size | number }} bytes
                </div>
              </div>
              <!-- Actions shown on hover or always on mobile -->
              <div class="flex items-center gap-1" [class.opacity-100]="doc._hover" [class.opacity-70]="!doc._hover">
                <a 
                  [href]="baseUrl + doc.url"
                  [attr.download]="doc.name"
                  target="_blank"
                  class="p-1 rounded-lg text-blue-600 hover:bg-blue-200 transition"
                  title="View & Download"
                >
                  <i class="pi pi-download"></i>
                </a>
               
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #noDocuments>
        <div class="p-2 text-gray-400 italic text-center text-xs flex items-center justify-center gap-2">
          <i class="pi pi-info-circle"></i> No documents attached
        </div>
      </ng-template>
    </div>
  `
})
export class StepDetailsComponent implements OnInit, AfterViewInit {
  @Input() applicantData: any;
  @Input() versionData: any;


  constructor(private apiService: ApiService, private zipDownloadService: ZipDownloadService) { }

  briefcaseData: any;
  baseUrl: string = environment.APIUrl;
  isLoading: boolean = true;

  ngOnInit(): void {
    // No need to log
  }

  ngAfterViewInit(): void {
    // Wait until applicantData is loaded
    if (this.applicantData) {
      this.loadBriefcaseData();
    } else {
      // Poll for applicantData to be loaded if it's not yet available
      const waitForApplicantData = setInterval(() => {
        if (this.applicantData) {
          this.loadBriefcaseData();
          clearInterval(waitForApplicantData);
        }
      }, 100);
    }
  }

  loadBriefcaseData() {

    this.isLoading = true;
    this.apiService
      .getAPI(
        `/idex/oc-dms/briefcase/${this.versionData?.id || this.applicantData.open_challenge_id}/${this.applicantData?.id}/`
      )
      .subscribe(
        (res: any) => {
          this.briefcaseData = res;
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  downloadAllDocumentsAsZip() {
    if (this.briefcaseData?.documents) {
      this.zipDownloadService.downloadDocsAsZip(
        this.briefcaseData.documents,
        `${this.briefcaseData.oc_folder_used + "_" + this.briefcaseData.challenge_number}.zip`
      );
    }
  }
}
@Component({
  standalone: true,
  selector: 'app-oc-proposal-upload',
  templateUrl: './oc-proposal-upload.component.html',
  providers: [MessageService],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RadioButtonModule,
    DropdownModule,
    TableModule,
    DialogModule,
    ToastModule,
    EditorModule,
    SharedModule,
    MultiSelectModule,
    StepDetailsComponent
  ],
})
export class OcProposalUploadComponent implements OnInit {
  @Input() type: string = '';
  @Input() url: string = '';
  @Input() title: string = 'OC Proposal Upload';
  @Input() stepDetails: any;
  @Input() currentStep: any;
  @Input() subScheme: any;
  tableData: any[] = [];
  role_id = sessionStorage.getItem('user_role_id');
  showSampleDialog: boolean = false;
  showNilRemarks: boolean = false;
  tableColumns: any[] = [
    { field: 'sr_no', header: 'Ser No.', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'challenge_number', header: 'Challenge No', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'applying_as', header: 'Applying as', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'themenetic', header: 'Thematic OC/Problem Statement', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'name', header: 'Name of Applicant', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'gender', header: 'Gender', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'phone_number', header: 'Phone Number', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'email', header: 'Email', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'address', header: 'Address', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'states', header: 'State', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'city', header: 'City', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'company_name', header: 'Company Name', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'designation_applicant', header: 'Designation of Applicant', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'company_website', header: 'Company Website', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'company_portfolio', header: 'Portfolio of the Company', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'innovation_title', header: 'Innovation Title', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'title_innovative', header: 'Title of Innovative Technology', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'nodal_dte', header: 'Nodal Dte', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'recommendations_1', header: 'PI 1 Recommendation', filterType: 'text', filterValue: '', vType: 'status' },
    { field: 'comments_1', header: 'PI 1 Remarks', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'recommendations_2', header: 'PI 2 Recommendation', filterType: 'text', filterValue: '', vType: 'status' },
    { field: 'comments_2', header: 'PI 2 Remarks', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'recommendations_3', header: 'PI 3 Recommendation', filterType: 'text', filterValue: '', vType: 'status' },
    { field: 'comments_3', header: 'PI 3 Remarks', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'status', header: 'Status', filterType: 'text', filterValue: '', vType: 'status' },
    { field: 'supporting_doc', header: 'Supporting Doc', filterValue: '', vType: 'supporting_doc' },
  ];
  filterColoum: any[] = [];
  init: EditorComponent['init'] = init;
  ocFrom: FormGroup = new FormGroup({
    id: new FormControl(null),
    name: new FormControl('', Validators.required),
    start_date: new FormControl('', Validators.required),
    end_date: new FormControl('', Validators.required),
    description: new FormControl(''),
    nodal_directorates: new FormControl(null),
    category: new FormControl(''),
    agencie_1: new FormControl(''),
    agencie_2: new FormControl(''),
    agencie_3: new FormControl(''),
  });
  brief: string = '';
  readonly requiredValidator = Validators.required;
  draftProposalColumns: any[] = [
    { field: 'proposal_name', header: 'Firm Name', filterType: 'text', filter: true },
    { field: 'modified_on', header: 'Last Update', filterType: 'text', filter: true },
  ]
  selectedProposals = []
  nodalDirectorates: any[] = [];
  categoryList: any[] = [
    { name: 'To Move', value: 'To Move' },
    { name: 'To Fight', value: 'To Fight' },
    { name: 'To Float', value: 'To Float' },
  ];

  selectedOCProposal: any;
  baseUrl: string = environment.APIUrl;
  constructor(private apiService: ApiService, private fb: FormBuilder, private route: ActivatedRoute, private messageService: MessageService, private zipDownloadService: ZipDownloadService) {
    // initialize column visibility (default: visible) and sync the filtered list
    this.tableColumns = this.tableColumns.map((col: any) => ({
      ...col,
      visible: col.visible !== false,
    }));
    this.syncVisibleColumns();
  }

  syncVisibleColumns() {
    this.filterColoum = this.tableColumns.filter((col: any) => col.visible !== false);
  }

  updateTableHeadersWithAgencies(agencie1: string, agencie2: string, agencie3: string) {
    // Update PI 1, 2, 3 recommendation and remarks headers based on agency names
    this.tableColumns.forEach((column: any) => {
      if (column.field === 'recommendations_1') {
        column.header = (agencie1 && agencie1.trim()) ? `${agencie1.trim()} Recommendation` : 'PI 1 Recommendation';
      } else if (column.field === 'comments_1') {
        column.header = (agencie1 && agencie1.trim()) ? `${agencie1.trim()} Comments` : 'PI 1 Comments';
      } else if (column.field === 'recommendations_2') {
        column.header = (agencie2 && agencie2.trim()) ? `${agencie2.trim()} Recommendation` : 'PI 2 Recommendation';
      } else if (column.field === 'comments_2') {
        column.header = (agencie2 && agencie2.trim()) ? `${agencie2.trim()} Comments` : 'PI 2 Comments';
      } else if (column.field === 'recommendations_3') {
        column.header = (agencie3 && agencie3.trim()) ? `${agencie3.trim()} Recommendation` : 'PI 3 Recommendation';
      } else if (column.field === 'comments_3') {
        column.header = (agencie3 && agencie3.trim()) ? `${agencie3.trim()} Comments` : 'PI 3 Comments';
      }
    });
    this.syncVisibleColumns();
  }
  ngOnInit(): void {
    this.getUnits();
    this.route.queryParams.subscribe((params: any) => {
      if (this.stepDetails === 'screening')
        this.getStepData(params.id);
    });
    if (this.stepDetails === 'approval')
      this.getSingaleProposal();

  }
  async finalSubmit() {
    this.messageService.clear('confirm');
    if (!this.fieData['file1'] || !this.fieData['file2']) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please upload both files.' });
      return;
    }
    const payload = new FormData();
    const formData = this.ocFrom.value;
    payload.append('name', formData.name);
    payload.append('scheme', String(7));
    payload.append('start_date', formData.start_date);
    payload.append('end_date', formData.end_date);
    payload.append('agencie_1', formData.agencie_1);
    payload.append('agencie_2', formData.agencie_2);
    payload.append('agencie_3', formData.agencie_3);
    const nodalDirectorates: any[] = this.ocFrom.get('nodal_directorates')?.value || [];

    nodalDirectorates.forEach((dirId: any) => {
      payload.append('nodal_directorates', String(dirId));
    });

    payload.append('proposal_file', this.fieData['file1']);
    payload.append('briefcase_file', this.fieData['file2']);


    console.log(payload);
    this.apiService.postAPI('/idex/oc/initiated/proposal/', payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Proposal shared successfully.' });
      if (res?.status === 'error' && res?.error_file_url) {
        // Construct full URL (important!)
        const baseUrl = this.baseUrl || window.location.origin;
        const fileUrl = baseUrl + res.error_file_url;

        // Open in new tab
        window.open(fileUrl, '_blank');

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: res?.message || 'Error file generated'
        });

        return;
      }

      // Success case
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res?.message || 'Proposal shared successfully.'
      });

      this.refreshForm();
    });
  }


  getUnits() {
    this.apiService.getAPI('/master/units/').subscribe((res: any) => {
      this.nodalDirectorates = res.data;
    });
  }

  applicantData: any;
  openPopup(proposal: any) {
    this.applicantData = proposal;
    this.displayUploadDialog = true;
  }

  deleteProposal(proposal: any) {
    this.selectedProposal = proposal;
    this.showDeleteConfirmDialog = true;
  }


  displayUploadDialog: boolean = false;

  populateDraftProposal(draft: any) {
    this.messageService.add({ severity: 'info', summary: 'Draft proposal populated successfully.' });
    this.selectedOCProposal = draft;
    this.ocFrom.patchValue({ ...draft, name: draft.title, scheme: 7 });
    this.tableData = draft?.oc_challenge || [];
  }


  responseData: any
  getStepData(id: any) {
    this.apiService.getAPI(`/master/oc/proposal/${id}/`).subscribe((res: any) => {
      this.responseData = res;
      this.responseData.nodal_directorates = this.nodalDirectorates.filter((nd: any) => this.responseData.nodal_directorates.includes(nd.id));

      // Update table column headers with agency names
      const agencie1 = (res.agencie_1 && res.agencie_1.trim()) ? res.agencie_1.trim() : '';
      const agencie2 = (res.agencie_2 && res.agencie_2.trim()) ? res.agencie_2.trim() : '';
      const agencie3 = (res.agencie_3 && res.agencie_3.trim()) ? res.agencie_3.trim() : '';
      this.updateTableHeadersWithAgencies(agencie1, agencie2, agencie3);
    });

    this.apiService.getAPI(`/idex/oc/upload/challenges/?oc_proposal=${id}`).subscribe((res: any) => {
      // Backend returns data with field names matching tableColumns structure:
      // sr_no, challenge_number, applying_as, themenetic, name, gender, phone_number, email,
      // address, states, city, company_name, designation_applicant, company_website, company_portfolio,
      // innovation_title, title_innovative, nodal_dte, recommendations_1, comments_1,
      // recommendations_2, comments_2, recommendations_3, comments_3, status
      this.tableData = Array.isArray(res) ? res : (res.data || res.results || []);
    });
  }
  getSingaleProposal() {
    this.apiService.getAPI(this.url).subscribe((res: any) => {
      if (['SCR-APP', 'S-C', 'C-APPR'].includes(this.currentStep.code)) {
        this.applicantData = res.challenge;
      } else {
        this.applicantData = res[0];
      }
    });
  }
  refreshForm() {
    // this.getStepData();
    this.ocFrom.reset();
    this.fieData = {
      'file1': null,
      'file2': null,
    };
  }

  showConform() {
    this.messageService.add({ key: 'confirm', sticky: true, summary: 'Are you sure you want to submit this proposal?' });
  }
  clear() {
    this.messageService.clear('confirm');
  }
  fieData = {
    'file1': null,
    'file2': null,
  }
  handleFileInput(event: Event, fileName: string) {
    const file = (event.target as HTMLInputElement).files[0];
    console.log(file);
    if (file) {
      this.fieData[fileName] = file;
    }
  }

  get areBothFilesUploaded(): boolean {
    return !!(this.fieData['file1'] && this.fieData['file2']);
  }


  reasonForReject: string = '';
  acceptSelectedProposals(action: string) {
    if (this.actionType === 'Nill') {
      this.nilReturn()
      return;
    }
    this.showConfirm = true;
    this.actionType = action;
    const payload = []
    const payloadRoute = []
    this.selectedProposals.forEach((proposal: any) => {
      payload.push({
        id: proposal?.id,
        status: action,
        brief: this.brief,
        recommended_by: sessionStorage.getItem('user_id')
      });
      if (action === 'Recommended') {
        const payloadRouteItem = {
          "proposal_step": proposal.next_proposal_step_id,
          is_external: this.shareType === 'external',
          is_final_editor: false,
          remarks: this.reasonForReject
        }
        if (this.shareType === 'internal') {
          payloadRouteItem['user'] = this.selectedUser.id;
        } else {
          payloadRouteItem['unit_id'] = this.selectedUnit;
        }
        payloadRoute.push(payloadRouteItem);
      }
    });
    this.apiService.putAPI(`/idex/oc/upload/challenges/`, payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Proposals recommended successfully.' });
      this.getStepData(this.responseData.id);
      this.selectedProposals = [];
      this.showConfirm = false;
      this.reasonForReject = '';
    });

    if (action === 'Recommended') {
      this.apiService.postAPI(`/file_mange/oc-scheme/editor/add/`, payloadRoute).subscribe((res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Proposals ' + action + ' successfully.' });
      });
    }
  }

  nilReturn() {
    this.apiService.postAPI(`/idex/nil-return/`, {
      "action": "create",
      "oc_proposal": this.responseData.id,
      "user": sessionStorage.getItem('user_id'),
      "remark": this.reasonForReject
    }).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Proposals Nill returned successfully.' });
      this.getStepData(this.responseData.id);
    });
  }
  openAcceptRejectPopup(action: string) {
    this.showConfirm = true;
    this.actionType = action;
    this.getUserList();
  }
  getStatusClass(status: string): string {
    switch (status) {
      case 'Recommended':
        return 'border-green-200 bg-green-100 text-green-700';
      case 'Rejected':
        return 'border-red-200 bg-red-100 text-red-700';
      default:
        return 'border-yellow-200 bg-yellow-100 text-yellow-700';
    }
  }

  getUserList() {
    const unit = parseInt(sessionStorage.getItem('unit_id') || '0');
    this.apiService.getAPI(`/account/users/?unit=${unit}`).subscribe((res: any) => {
      this.userList = res.data;
    });
  }
  userList: any[] = [];
  selectedUser: any;
  showConfirm: boolean = false;
  actionType: string = '';
  selectedCategory: string = '';
  shareType: string | null = null;
  selectedUnit: any;
  stepSubmit() {
    let payload = {};
    if (this.currentStep.code === 'SCR-APP') {
      payload['category'] = this.selectedCategory
    } else if (this.currentStep.code === 'S-C') {
      payload['challenge_status'] = this.selectedCategory
    }
    this.apiService.putAPI(`/idex/oc/upload/challenges/${this.applicantData.id}/`, payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Proposal category updated successfully.' });
      this.getSingaleProposal();
    })
  }
  onShareTypeChange(event: any) {
    if (event.value === 'internal') {
      this.getUserList();
    } else {
      this.getUnits();
    }

  }
  downloadProposal(proposal: any) {
    this.apiService.getAPI(`/idex/oc-dms/briefcase/${this.responseData.id}/${proposal.id}/`).subscribe((res: any) => {
      this.zipDownloadService.downloadDocsAsZip(res.documents, `${res.oc_folder_used + "_" + res.challenge_number}.zip`);
    });
  }

  showDeleteConfirmDialog: boolean = false;
  selectedProposal: any;
  confirmDelete() {

    this.showDeleteConfirmDialog = false;
    this.apiService.postAPI(`/idex/oc-application/update/`, { "action": "delete", "id": this.selectedProposal.id }).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Proposal deleted successfully.' });
      this.getStepData(this.responseData.id);
    });
  }
}


